export const blockIconsCommunicationPhone = (
	<span className='material-symbols-outlined'>phone</span>
);
